import React from "react";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectToken } from "../store/slices/authSlice";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const token = useSelector(selectToken);
  const location = useLocation();

  const isUserAuthenticated = isAuthenticated && token;

  if (!isUserAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
